// extracted by mini-css-extract-plugin
export default {"varSpUp11":"3.75rem","container":"container--493c9"};